<template lang="html">
	<section>
		<article class="anonymous-documents column" v-if="isAnonymous">
			<div class="title">
				Vous avez la possibilité de remplir votre <br/>
				Paysage Patrimonial anonymement
			</div>
			<div class="subtitle">
				et de le compléter plus tard
			</div>
			<router-link class="btn btn-red" :to="{ name: 'PatrimonialLandscape' }">
				Completer mon Paysage Patrimonial anonymement
			</router-link>
		</article>
		<article class="white-box column subscriptions-master" v-else>
			<div class="head column">
				<div class="title">Abonnement</div>
				<div class="date" v-if="isSubscriptionEnabled">Votre abonnement est activé</div>
				<div class="date" v-else>Pas d'abonnement en cours</div>
				<div class="status column" v-if="isSubscriptionEnabled && currentSubscription.payment_type === 'automatic' && currentSubscription.next_billing_date">
					<div class="title">Renouvellement automatique</div>
					<div class="next-release">Prochain prélévement le {{$moment(currentSubscription.next_billing_date, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY')}}</div>
				</div>
			</div>
			<div class="body column">
				<div class="label bold">
					Vos moyens de paiement
				</div>
				<div class="ctn-payments">
					<div class="payment row" v-for="(paymentMethod, key) in paymentMethods" v-bind:key="key">
						<div class="left column">
							<div class="label">
								Carte bancaire
							</div>
							<div class="number">
                {{capitalizeText(paymentMethod.card_brand)}} ******{{paymentMethod.card_last4}}
							</div>
						</div>
						<div class="left column expiration-column">
							<div class="label">
								Expiration
							</div>
							<div class="number">
								{{ paymentMethod.exp_month }}/{{ paymentMethod.exp_year }}
							</div>
						</div>
						<div :class="'status center ' + getPaymentMethodStatusClass(paymentMethod)">
							{{ getPaymentMethodStatusLabel(getPaymentMethodStatusClass(paymentMethod)) }}
						</div>
						<div class="right row">
							<span class="icon-file-edit" @click="emitEditPaymentMethod(paymentMethod)"></span>
							<span class="icon-file-trash" v-if="!paymentMethod.is_default" @click="deletePaymentMethod(paymentMethod)"></span>
						</div>
					</div>
				</div>
				<div class="btn btn-gold" @click="emitNewPaymentMethod">
					Ajouter un moyen de paiement
				</div>
			</div>
		</article>

    <base-modal :show="showPaymentMethodModal" :data="dataPaymentMethod" :content="paymentMethod" @close="showPaymentMethodModal=false" />
    <base-modal :show="showConfirmPaymentModal" :data="{}" :content="confirmPayment" @close="showConfirmCardPayment" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentMethod from './PaymentMethodModal/PaymentMethod'
import ConfirmPayment from './ConfirmPaymentModal/ConfirmPayment'
import StripeForm from '@/common/services/StripeForm'

export default {
	components: {
	},
	data () {
		return {
			showPaymentMethodModal: false,
			showConfirmPaymentModal: false,
			dataPaymentMethod: null,
			paymentMethod: PaymentMethod,
			confirmPayment: ConfirmPayment,
			payments: [],
			stripeForm: null
		}
	},
	mounted () {
		this.stripeForm = new StripeForm({})

		this.$store.dispatch('getPaymentMethods')
		this.$store.dispatch('getSubscriptions')
	},
	methods: {
		capitalizeText (text) {
			return text.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
		},
		emitNewPaymentMethod () {
			this.dataPaymentMethod = {}
			this.showPaymentMethodModal = true
		},
		emitEditPaymentMethod (paymentMethod) {
			this.dataPaymentMethod = paymentMethod
			this.showPaymentMethodModal = true
		},
		getPaymentMethodStatusLabel (s) {
			let r = null
			switch (s) {
			case 'default':
				r = 'Par Défaut'
				break
			case 'expired':
				r = 'Expiré'
				break
			default:
				r = ''
			}

			return r
		},
		getPaymentMethodStatusClass (paymentMethod) {
			if (paymentMethod.is_expired) {
				return 'expired'
			}

			if (paymentMethod.is_default) {
				return 'default'
			}
		},
		deletePaymentMethod (paymentMethod) {
			this.$swal.fire({
				title: 'Etes-vous sûr ?',
				text: 'La carte bancaire sera supprimée',
				icon: 'warning',
				confirmButtonColor: '#ff4052',
				showCancelButton: true,
				confirmButtonText: 'Supprimer',
				cancelButtonText: 'Annuler'
			}).then((result) => {
				if (result.value) {
					this.processPaymentMethodDeletion(paymentMethod)
				}
			})
		},

		processPaymentMethodDeletion (paymentMethod) {
			this.$store.dispatch('deletePaymentMethod', {
				payment_method_id: paymentMethod.id
			}).then(() => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Carte bancaire supprimée',
					text: 'La carte bancaire a bien été supprimée'
				})
			}).catch(() => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Erreur',
					text: 'Une erreur est survenue lors de la suppression'
				})
			})
		},

		showConfirmCardPayment () {
			this.showConfirmPaymentModal = false

			if (!this.lastPaymentFailInfo) {
				return
			}

			if (typeof this.lastPaymentFailInfo.paymentMethod !== 'undefined' &&
			typeof this.lastPaymentFailInfo.clientSecret !== 'undefined') {
				this.stripeForm
					.confirmCardPayment(this.lastPaymentFailInfo.clientSecret, this.lastPaymentFailInfo.paymentMethod)
					.then(this.handleConfirmCardPayment)
			} else if (typeof this.lastPaymentFailInfo.clientSecret !== 'undefined') {
				this.stripeForm
					.handleCardAction(this.lastPaymentFailInfo.clientSecret)
					.then(this.handleConfirmCardPayment)
			}

			this.stripeForm
				.confirmCardPayment(this.lastPaymentFailInfo.clientSecret, this.lastPaymentFailInfo.paymentMethod)
				.then(this.handleConfirmCardPayment)
		},

		handleConfirmCardPayment (result) {
			console.log(result)

			if (result.error) {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Erreur',
					text: result.error.message
				})
			} else {
				if (result.paymentIntent.status === 'succeeded') {
					this.notifyCardConfirmSuccess(result)
					this.$notify({
						type: 'success',
						group: 'default',
						title: 'Paiement',
						text: 'Votre paiement a bien été confirmé !'
					})
				}
			}
		},

		notifyCardConfirmSuccess (result) {
			let data = {
				payment_intent_id: result.paymentIntent.id,
				client_secret: this.lastPaymentFailInfo.clientSecret
			}

			this.$store.dispatch('confirmPayment', data)
		}
	},
	computed: {
		...mapGetters({
			isAnonymous: 'isAnonymous',
			paymentMethods: 'paymentMethods',
			currentSubscription: 'currentSubscription',
			lastPaymentFailInfo: 'lastPaymentFailInfo'
		}),

		isSubscriptionEnabled () {
			return this.currentSubscription && this.currentSubscription.status === 'enabled'
		}
	},

	watch: {
		lastPaymentFailInfo (newValue) {
			this.showConfirmPaymentModal = typeof newValue.clientSecret !== 'undefined'
		}
	}
}
</script>

<style lang="css">
.expiration-column {
    margin-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/Documents/MySubscriptions.vue